<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md5 lg5 xl4>
        <v-card outlined tile height="100%">
          <v-layout wrap justify-start fill-height>
            <v-flex xs12 align-self-center>
              <span class="hidden-md-and-up">
                <v-img
                  v-if="!curImage"
                  :src="mediaURL + productPhotos[0]"
                  max-height="60vh"
                  contain
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#FF2323"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-img
                  v-if="curImage"
                  :src="mediaURL + curImage"
                  max-height="60vh"
                  contain
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#FF2323"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </span>
              <span class="hidden-sm-and-down">
                <image-magnifier
                  v-if="!curImage"
                  :src="mediaURL + productPhotos[0]"
                  :zoom-src="mediaURL + productPhotos[0]"
                  width="400"
                  height="300"
                  zoom-width="400"
                  zoom-height="300"
                ></image-magnifier>
                <image-magnifier
                  v-if="curImage"
                  :src="mediaURL + curImage"
                  :zoom-src="mediaURL + curImage"
                  width="400"
                  height="300"
                  zoom-width="400"
                  zoom-height="300"
                ></image-magnifier>
              </span>
            </v-flex>
            <v-flex xs11>
              <v-card tile flat>
                <v-layout wrap justify-center>
                  <v-flex xs2 v-for="(item, i) in productPhotos" :key="i">
                    <v-card @click="showImage(item)" flat tile>
                      <v-layout wrap justify-center>
                        <v-flex pa-2>
                          <v-img :src="mediaURL + item" height="100px" contain>
                            <template v-slot:placeholder>
                              <ImageLoader />
                            </template>
                          </v-img>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md7 lg7 xl8>
        <v-layout wrap justify-center pt-3>
          <v-flex xs11>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span
                  :style="
                    $vuetify.breakpoint.name == 'xs' ||
                    $vuetify.breakpoint.name == 'sm'
                      ? 'font-family: poppinsbold;font-size: 19px;color: #000000;'
                      : 'font-family: poppinsbold;font-size: 22px;color: #000000;'
                  "
                >
                  {{ productData.name }}
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 15px;
                    color: #979797;
                  "
                >
                  {{ productData.description }}
                </span>
              </v-flex>

              <v-flex xs12>
                <v-layout wrap justify-center>
                  <v-flex xs12 sm6>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          :style="
                            $vuetify.breakpoint.name == 'xs' ||
                            $vuetify.breakpoint.name == 'sm'
                              ? 'font-family: poppinssemibold;font-size: 20px;color: #000000;'
                              : 'font-family: poppinssemibold;font-size: 27px;color: #000000;'
                          "
                        >
                          Rs. {{ productData.price }}
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left pt-4>
                        <v-btn
                          small
                          depressed
                          class="text-capitalize"
                          color="#FF1313"
                          tile
                          v-if="productData.discount > 0"
                        >
                          <span
                            style="
                              font-family: poppinsmedium;
                              font-size: 12px;
                              color: #ffffff;
                            "
                          >
                            Today Rs.{{ productData.offerPrice }},
                            {{ productData.discount }}% Off
                          </span>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 text-left py-1>
                        <span
                          v-if="productData.stockQuantity > 0"
                          class="pl-4"
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #52d25b;
                          "
                        >
                          In Stock ({{ productData.stockQuantity }} pieces left)
                        </span>
                        <span
                          v-if="productData.stockQuantity <= 0"
                          class="pl-4"
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #ff4343;
                          "
                        >
                          Out of Stock
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 lg6 text-left align-self-center>
                    <v-layout wrap justify-start align-content-center>
                      <v-flex xs3 lg3 text-left px-2 align-self-center>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #8f8f8f;
                          "
                          class="caption"
                        >
                          {{ productData.rating }}
                        </span>
                        <br />
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #8f8f8f;
                          "
                          class="caption"
                        >
                          Reviews
                        </span>
                      </v-flex>
                      <v-divider vertical></v-divider>
                      <v-flex
                        xs6
                        lg5
                        text-left
                        px-2
                        align-self-center
                        text-center
                      >
                        <v-rating
                          v-model="productData.rating"
                          color="#FFD341"
                          background-color="#e0e0e0"
                          empty-icon="$ratingFull"
                          half-increments
                          readonly
                          hover
                          small
                        ></v-rating>
                      </v-flex>

                      <v-divider vertical></v-divider>
                      <v-flex
                        xs3
                        lg3
                        text-left
                        px-2
                        align-self-center
                        text-center
                      >
                        <v-icon>mdi-heart-outline</v-icon>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #8f8f8f;
                          "
                          class="caption"
                          >&nbsp;{{ productData.wishlistCount }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- Hypermart  -->
              <v-flex
                xs12
                py-0
                text-left
                v-if="appCategory == '5fdc6f29de6a0c4260faa145'"
                class=""
              >
                <v-layout wrap v-if="productData.brand" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Brand</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.brand }}
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-if="productData.manufacturer" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Manufacturer</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.manufacturer }}
                    </span>
                  </v-flex>
                </v-layout>
                
                <v-layout wrap v-if="productData.disclaimer" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Disclaimer</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.disclaimer }}
                    </span>
                  </v-flex>
                </v-layout>
                 <v-layout wrap v-if="productData.ingredientType" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Ingredient Type</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.ingredientType }}
                    </span>
                  </v-flex>
                </v-layout>

                <v-layout wrap v-if="productData.ingredients" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Ingredients</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.ingredients }}
                    </span>
                  </v-flex>
                </v-layout>

                <v-layout wrap v-if="productData.howtouse" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">How to Use</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.howtouse }}
                    </span>
                  </v-flex>
                </v-layout>

                 <v-layout wrap v-if="productData.featuresandDetails" py-2>
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Features and Details</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <span class="ibmlight smallm cblack">
                      {{ productData.featuresandDetails }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- Electronics  -->
              <v-flex
                xs12
                py-0
                text-left
                v-if="appCategory == '5fdc6f06de6a0c4260faa143'"
              >
                <v-layout wrap v-if="productData.isColor">
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold">Available colors/Stock</span>
                  </v-flex>
                  <v-flex xs12 py-0 text-left>
                    <v-layout wrap justify-start>
                      <v-flex
                        xs1
                        sm1
                        lg1
                        pa-2
                        v-for="(item, i) in productData.colorDetails"
                        :key="i"
                      >
                        <v-avatar :color="item.colorHex" size="20"></v-avatar>
                        <br />
                        <span class="ibmbold appColor">{{ item.stock }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                py-0
                text-left
                v-if="appCategory == '601e2b174b2e12e49fd4da3c'"
              >
                <v-layout wrap v-if="productData.subcategoryId">
                  <v-flex xs12 py-1 text-left>
                    <span class="ibmsemibold cblack">{{
                      productData.type
                    }}</span>
                    /
                    <span class="ibmsemibold cblack">{{
                      productData.subcategoryId.name
                    }}</span>
                  </v-flex>
                  <!-- <v-flex xs12 py-0 text-left>
                    
                  </v-flex> -->
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                py-2
                text-left
                v-if="appCategory == '5fdc6f06de6a0c4260faa143'"
              >
                <span
                  style="font-family: poppinsbold; font-size: 14px; color: #000"
                  >Specification</span
                >
                <br />

                <span
                  style="
                    font-family: poppinslight;
                    font-size: 14px;
                    color: #707070;
                  "
                >
                  {{ productData.specification }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <!-- <v-flex xs12 sm6 md6 lg5 xl4>
        <v-chip-group column>
          <v-chip v-for="(item, i) in productData.tags" :key="i">
            {{ item }}
          </v-chip>
        </v-chip-group>
      </v-flex> -->
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["productData", "productPhotos"],
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      ServerError: false,
      msg: null,
      colors: [
        { color: "#C2C2C2", quantity: 23 },
        { color: "#EE2749", quantity: 87 },
        { color: "#000000", quantity: 12 },
        { color: "#5E0C0C", quantity: 32 },
        { color: "#4251D1", quantity: 241 },
        { color: "#4251D1", quantity: 241 },
      ],
      promoCode: null,
      productSize: {},
      selectedProduct: {},
      curImage: null,
    };
  },
  computed: {
    appCategory() {
      return this.$store.state.categoryId;
    },
  },
  methods: {
    showImage(item) {
      this.curImage = item;
    },
    changeSize(item) {
      this.productSize = item;
    },
    selectProduct(item) {
      this.selectedProduct = item;
    },
  },
};
</script>
<style scoped>
.colorselector.v-sheet.v-card {
  border-radius: 35px;
}
.sizebutton.v-btn:not(.v-btn--round).v-size--small {
  /* min-width: 50px; */
  padding: 0 12px !important;
  min-width: 30px !important;
}
</style>
